export default __webpack_public_path__ + "static/media/AssetHouseLogo.a9961d52.png";